import { cn } from '@/lib/utils'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'dark'
  size?: 'sm' | 'md' | 'lg'
}

export function Button({ variant = 'primary', size = 'md', className, children, ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center font-medium rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand/30',
        {
          'bg-brand text-white hover:bg-brand-hover': variant === 'primary',
          'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50': variant === 'secondary',
          'text-gray-600 hover:text-gray-900': variant === 'ghost',
          'bg-gray-900 text-white hover:bg-gray-800': variant === 'dark',
          'px-3 py-1 text-xs': size === 'sm',
          'px-5 py-2 text-sm': size === 'md',
          'px-6 py-3 text-base': size === 'lg',
        },
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
